// extracted by mini-css-extract-plugin
export default {"icon":"SmoPageImage_icon__CMPyI","text":"SmoPageImage_text__yIZqu","textMoveY":"SmoPageImage_textMoveY__iT5oa","image":"SmoPageImage_image__G0Hsk"};